import { Reveal } from "./Reveal";
import { SectionLabel } from "./SectionHeading";

export const PageHero = ({ label, title, text }) => (
  <section className="relative bg-[#020A12] pt-40 pb-24 overflow-hidden">
    <div className="absolute inset-0 mst-dot-pattern opacity-20" />
    <div className="absolute -top-32 right-0 w-[560px] h-[560px] rounded-full bg-[#006FD6]/15 blur-3xl" />
    <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
      <Reveal>
        <SectionLabel light>{label}</SectionLabel>
        <h1 className="mt-6 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white leading-[1.08] max-w-3xl">
          {title}
        </h1>
        {text && <p className="mt-7 text-[#B7C0CC] leading-[1.8] max-w-2xl text-base sm:text-lg">{text}</p>}
      </Reveal>
    </div>
  </section>
);
